export default {
  label: "overflow",
  valueScope:[
    'overflow-auto',
    'overflow-hidden',
  ]
}


// WEBPACK FOOTER //
// ./src/shell/schemas/utilities/overflow.js